import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { CommonService } from "../../core/service/common-service/common.service";
import { DatePipe } from "@angular/common";
import { interval } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TimepickerRef } from "ngx-material-timepicker/src/app/material-timepicker/models/timepicker-ref.interface";
import * as _moment from 'moment';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { MatDialog } from '@angular/material/dialog';
import { ServicenotrequireDailogComponent } from "../servicenotrequire-dailog/servicenotrequire-dailog.component";
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { element } from 'protractor';
import { SaveCallRecordingParams } from "src/app/model/save-call-recording-params.model";
import { MatTableDataSource } from '@angular/material/table';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'LL',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: "app-calling-dialog",
  templateUrl: "./calling-dialog.component.html",
  styleUrls: ["./calling-dialog.component.scss"],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
})
export class CallingDialogComponent implements OnInit {
  @Input() vinNoList: any[];
  @Input() serviceDetails: any;
  @Input() selectedVin: string;
  @Input() customerNumber: string;
  @Input() custName: string;
  @Input() isCustomerNumber: string;
  @Input() primaryNumber: string;
  // @Input() bookingCount: number;
  // @Input() followupCount: number;
  @Input() division: string;
  @Input() workshopAppointmentFlag: string;
  @Input() ownerSelected: boolean;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() phoneNo:any;
  @Input() cusType:any;
  @Input() custNameForSave:string;
  @Input() serviceCount:number;
  userRoles: string;

  constructor(
    private datePipe: DatePipe,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) { }

  startTime: any;
  serviceDueDate: any;
  talked: string = "";
  creRemark: string = "";
  custmerName: string;
  yesResponce: string = "";
  noResponce: string = "";
  nsReason: string = "";
  customerId: string;
  userID: string;
  customerData: any;
  workshop: string = "";
  workshopSelected: string = "";
  workShops = <any>[];
  selectedWorkShop: string;
  other: string = "";
  odometer: string = "";
  timer: string;
  today: Date = new Date();
  min: number = 0;
  sec: number = 0;
  callhanged: boolean;
  spinner: boolean;
  disSatSerArr: string[] = [];
  vinNoListArray: string[] = [];
  vehicleInfoArray: any[] = [];
  yesResArr: string[] = [];
  servNotReqArr: string[] = [];
  alreadyServicedArr: string[] = [];
  defaultVin: string;
  responseDropDownData: any;
  level1info = [];
  level1Form: FormGroup;
  level2info = [];
  level2Form: FormGroup;
  level3info = [];
  level3Form: FormGroup;
  level4info = [];
  level4Form: FormGroup;
  level5info = [];
  level5Form: FormGroup;
  callTypeMap = new Map();
  currentDate = new Date();
  serviceInfo: any;
  chassisNo: string;
  submitted: boolean = false;
  formSubmitted: boolean = false;
  showNoRespError: boolean = false;
  milage: any;
  odometerEntry: any;
  assignedBay: any;
  workShopBay: any = {};
  bayError: boolean = false;
  bayOpen: any;
  bayClose: any;
  serviceHours: any;
  bayLayout: any = [];
  selectedBay: any = [];
  showBay: boolean = false;
  selectedBayNo: any = '';
  bayEndTime: any;
  fertCode: any;
  packagelist: any[] = [];
  bookingandResheduleMaxDate: Date = new Date();
  followupandCancleMaxDate: Date = new Date();
  showRemarkError: boolean = false;
  countFlag: boolean = false;
  bookFllowCountFlag: boolean = false;
  vin: string;
  showFleetManError: boolean = false;
  alReadyServicMaxDate: Date = new Date();
  bookingCount: number;
  followupCount: number;
  serviceMintus: any;
  maxDate : Date = new Date();
  countryCode: string;

  @Input("timepicker")
  timePicker: TimepickerRef;

  //chart1Bar start
  public chartOptions: ChartOptions = {
    responsive: true,
    tooltips: {
      enabled: false
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            display: true
          },
          ticks: {
            beginAtZero: false,
            fontSize: 10,
            stepSize: 1,
            autoSkip: false
          }
        }
      ],
      yAxes: [{
        display: false,
        gridLines: {
          display: false
        }
      }]
    }
  };
  public chartLabels: any[] = [];
  public chartType: ChartType = 'horizontalBar';
  public chartLegend = false;
  public chartPlugins = [];
  public chartData: any = [];

  userInfo:any;
  pickUp: string = "NO";
  startTitanSlotTime: any;
  endTitanSlotTime: any;
  showTitanBay: boolean = false;
  showTitanSlotTable: boolean = false;
  slotSelected: string | null = null; // Track the selected slot
  baySelected: any = 1;
  displayedColumns: string[] = ['bay']; // Initialize with bay column
  dataSource = new MatTableDataSource<any>(); // Data source for the table
  slots: any[] = []; // Array to hold slot data
  bookedSlots: any[] = [];

  ngOnInit() {
  this.userInfo = JSON.parse(localStorage.getItem("userInfo") || null)[0];
  this.showTitanBay = this.userInfo.verticalName == "SCV" ? true : false;
      this.customerData = JSON.parse(localStorage.getItem("customerData") || null);
    if (
      localStorage.getItem("userId") == null ||
      localStorage.getItem("userId") == undefined
    ) {
      this.router.navigate(["login"]);
    }
    this.countryCode = localStorage.getItem("countryCode");
    this.customerId = localStorage.getItem("customerId");
    this.userID = localStorage.getItem("userId");
    this.customerData = JSON.parse(localStorage.getItem("customerData"));
    this.vin = this.customerData.vin;
    this.workshopSelected = localStorage.getItem("dealerName");
    this.custmerName = this.customerData.customerName;
    this.vin = this.customerData.vin;
    this.workShops = JSON.parse(localStorage.getItem('workshops'));
    this.selectedWorkShop = (this.workShops && this.workShops.length) ? this.workShops[0].workshopCode : '';
    this.serviceInfo = JSON.parse(localStorage.getItem("serviceInfo"));
    this.userRoles = localStorage.getItem('userRoles');
    this.chassisNo = localStorage.getItem("chassisNo");
    this.serviceDueDate = this.datePipe.transform(
      localStorage.getItem("serviceDueDate"),
      "yyyy-MM-dd"
    );
    this.startTime = new Date();
    this.callTypeMap.set("Service", 4);
    this.callTypeMap.set("Reminder", 2);
    this.callTypeMap.set("Visit", 1);
    this.callTypeMap.set("No Show", 3);
    //this.showBay = this.workshopAppointmentFlag;
    if (Object.keys(this.serviceInfo).length && this.serviceInfo[this.selectedVin]) {
      this.fertCode = this.serviceInfo[this.selectedVin].fertCode || '';
      let serviceType = this.serviceInfo[this.selectedVin].serviceType.split(' - ')[0];
      if(this.workshopAppointmentFlag == 'true') {
        if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          this.showBay = true;
          this.getFertPrice(this.selectedWorkShop, this.fertCode);
          if(this.showTitanBay) {
            this.getTitanWorkshopBay();  // Fetch titan workshop slots on initialization
          } else {
            this.getWorkshopBay();
          }
        } else {
          this.showBay = false;
        }
      } else {
        this.showBay = false;
      }
      // if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
      //   //this.showBay = true;
      //   this.getFertPrice(this.selectedWorkShop, this.fertCode);
      // }
    }

    this.odometerEntry = parseInt(localStorage.getItem("milage")) || 0;

    this.getBookingFollowupCount(this.customerId, this.vin);
    this.setVinList(this.selectedVin, false);
    this.setYesResponse();
    this.setSerReqArr();
    this.setAlreadyServicedArr();
    this.setDisSatWithPrevSerArr();
    this.setTimer();

    this.bookingandResheduleMaxDate.setDate(this.bookingandResheduleMaxDate.getDate() + 15);
    this.followupandCancleMaxDate.setDate(this.followupandCancleMaxDate.getDate() + 15);

    if(!this.showTitanBay) {
      if (this.serviceCount >= 0) {
        if (this.serviceCount % 2 == 1) {
          this.serviceHours = 1;
          this.serviceMintus = 30;
        } else {
          this.serviceHours = 4;
          this.serviceMintus = 0;
        }
      }
    } else {
      this.serviceHours = 1;
      this.serviceMintus = 30;
    }
  }

  /**
   * Name: closeDailog
   * purpose: To close Dailog
   */
  closeDailog(): void {
    this.close.emit(null);
  }
  /**
   * Name: onKeydown
   * purpose: To handle onKeydown event
   */
  onKeydown(event){
    event.preventDefault();
  }

  /**
   * Name: setVinList
   * purpose: To set Vin List
   */
  setVinList(defaultVin: any, vehicleChange: boolean): void {
    var vinListStr = Object.values(this.vinNoList);
    vinListStr.forEach(vin => {
      if (vin == defaultVin) {
        this.defaultVin = vin;
      }
    });
    for (let i = 0; i < vinListStr.length; i++) {
      this.vinNoListArray.push(vinListStr[i]);
    }
    if (vehicleChange) {
      this.serviceDetails = this.serviceInfo[defaultVin];
      this.fertCode = this.serviceDetails.fartCode;
      let serviceType = this.serviceInfo[this.selectedVin].serviceType.split(' - ')[0];
      if(this.workshopAppointmentFlag == 'true') {
        if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          this.showBay = true;
          this.getFertPrice(this.selectedWorkShop, this.fertCode);
        } else {
          this.showBay = false;
        }
      } else {
        this.showBay = false;
      }
      // let serviceType = this.serviceDetails.serviceType.split(' - ')[0];
      // if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
      //   this.showBay = this.workshopAppointmentFlag;
      //   this.getFertPrice(this.selectedWorkShop, this.fertCode);
      // } else {
      //   this.showBay = this.workshopAppointmentFlag;
      // }
      this.bayError = false;
      this.callStatus("101");
    }
  }

  /**
   * Name: setYesResponse
   * purpose: To set Yes Response
   */
  setYesResponse(): void {
    this.yesResArr.push("Book a Service");
    this.yesResArr.push("Call Later");
    this.yesResArr.push("Customer asked to contact Fleed Manager");
    this.yesResArr.push("Service Not Required");
  }

  /**
   * Name: setSerReqArr
   * purpose: To set SerReqArr
   */
  setSerReqArr(): void {
    this.servNotReqArr.push("Wrong Odometer Prediction");
    this.servNotReqArr.push("Already Serviced");
    this.servNotReqArr.push("Vehicle Sold");
    this.servNotReqArr.push("Dissatisfied with Previous Service");
    this.servNotReqArr.push("Distance from Dealer Location");
    this.servNotReqArr.push("Dissatisfaction with Sales");
    this.servNotReqArr.push("Dissatisfaction with Insurance");
    this.servNotReqArr.push("Other");
    this.servNotReqArr.push("Customer Not intersted");
    this.servNotReqArr.push(
      "Do not Create Calls for this This Truck in Future"
    );
  }

  /**
   * Name: setAlreadyServicedArr
   * purpose: To set Already Serviced Arr
   */
  setAlreadyServicedArr(): void {
    this.alreadyServicedArr.push("Service Done at Own Dealer");
    this.alreadyServicedArr.push("*Service Done at Other Dealer");
    this.alreadyServicedArr.push("*Service Done at local workshop");
  }

  /**
   * Name: setDisSatWithPrevSerArr
   * purpose: To set DisSatWithPrevSerArr
   */
  setDisSatWithPrevSerArr() {
    this.disSatSerArr.push("High Cost");
    this.disSatSerArr.push("Poor Service");
    this.disSatSerArr.push("Washing, Noise");
    this.disSatSerArr.push("Demanded Repairs");
    this.disSatSerArr.push("Delay in Delivery");
    this.disSatSerArr.push("Problem with Estimate");
    this.disSatSerArr.push("Staff Behaviour");
    this.disSatSerArr.push("Parts Not Available");
    this.disSatSerArr.push("Other");
  }

  /**
   * Name: setTimer
   * purpose: To setTimer
   */
  setTimer() {
    interval(1000).subscribe(x => {
      if (!this.callhanged) {
        this.sec++;
        if (this.sec == 60) {
          this.sec = 0;
          this.min++;
        }
        this.timer = this.min + ":" + this.sec;
      }
    });
  }

  /**
   * Name: callStatus
   * purpose: To check call status
   * @param {string} status - call status
   */
  callStatus(status: string): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    if ("101" == status) {
      this.talked = "101";
      this.noResponce = "";
      const self = this;
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.level3Form = undefined;
      this.level3info = [];
      this.level4Form = undefined;
      this.level4info = [];
      this.level5Form = undefined;
      this.level5info = [];

      let callType = this.callTypeMap.get(this.serviceInfo[this.defaultVin] && this.serviceInfo[this.defaultVin].callType)
      this.commonService.getDropdownData(callType).subscribe(res => {
        if (res["responseCode"] == 0) {
          let data = res["responseData"];
          if (Object.keys(data['Level2']).length && data['Level2']['201'] && data['Level2']['201'].length) {
            data['Level2']['201'].forEach(element => {
              if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '301') {
                element.label = 'Select Workshop';
              }
            });
          }
          if (Object.keys(data['Level2']).length && data['Level2']['210'] && data['Level2']['210'].length) {
            data['Level2']['210'].forEach(element => {
              if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '301') {
                element.label = 'Select Workshop';
              }
            });
          }
          if (Object.keys(data['Level2']).length && data['Level2']['211'] && data['Level2']['211'].length) {
            data['Level2']['211'].forEach(element => {
              if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '301') {
                element.label = 'Select Workshop';
              }
            });
          }
          if (Object.keys(data['Level2']).length && data['Level2']['212'] && data['Level2']['212'].length) {
            data['Level2']['212'].forEach(element => {
              if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '301') {
                element.label = 'Select Workshop';
              }
            });
          }
          // if (Object.keys(data['Level4']).length && data['Level4']['403'] && data['Level4']['403'].length) {
          //   data['Level4']['403'].forEach(element => {
          //     if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '502') {
          //       element.label = 'Select Workshop';
          //       element.dataType = "Dropdown";
          //     }
          //   });
          // }
          if (Object.keys(data['Level2']).length && data['Level2']['212'] && data['Level2']['212'].length) {
            data['Level2']['212'].forEach(element => {
              if (Object.keys(element).length && element.data.length && element.data[0].key && element.data[0].key == '301') {
                element.label = 'Select Workshop';
                element.dataType = "Dropdown";
              }
            });
          }

          self.responseDropDownData = data;
          this.createLevel1Form(data["Level1"]);
        }
      }, error => {
        this.toastr.error(error, "Error");
        this.spinner = false;
      });
    } else {
      this.talked = "102";
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.level3Form = undefined;
      this.level3info = [];
      this.level4Form = undefined;
      this.level4info = [];
      this.level5Form = undefined;
      this.level5info = [];
      this.yesResponce = "";
      this.nsReason = "";
      this.workshop = "";
      this.odometer = "";
    }
  }

  /**
   * Name: createLevel1Form
   * purpose: To create Level1 Form
   * @param {any} data - form data
   */
  createLevel1Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    const formDataObj = {};
    for (const prop of data) {
      formDataObj[prop.label] = new FormControl("", [Validators.required]);
      if (prop.dataType == "Dropdown") {
        var dropDownData = [];
        let serviceType = this.serviceDetails.serviceType.split(' - ')[0];
        let countRemoveFlag:boolean = false;
        this.countFlag = false;
        if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          countRemoveFlag = true;
          this.countFlag = true;
        }

        prop.data.forEach((element) => {
          if (!(countRemoveFlag && this.bookingCount < 0 && element.key == "201")
          && !(countRemoveFlag && this.followupCount < 0 && element.key == "202"))
          {
            dropDownData.push({ value: element.key, viewValue: element.value });
          }
        });
      }
      this.level1info.push({
        label: prop.label,
        type: prop.dataType,
        data: prop.dataType === "Dropdown" ? dropDownData : prop.data
      });
    }
    this.level1Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel2Form
   * purpose: To create Level2 Form
   * @param {any} data - form data
   */
  createLevel2Form(data: any): void {
    this.slotSelected = '';
    this.baySelected = 1;
    this.showTitanSlotTable = false;
    this.formSubmitted = false;
    this.showRemarkError = false;
    this.level2Form = undefined;
    this.level2info = [];
    this.level3Form = undefined;
    this.level3info = [];
    this.level4Form = undefined;
    this.level4info = [];
    this.level5Form = undefined;
    this.level5info = [];
    const formDataObj = {};
    let selection = this.level1Form.controls["Select Reason"].value;
    if (data[selection] && data[selection].length) {
      for (const prop of data[selection]) {
        if (prop.dataType == "Dropdown") {
          if (prop.data[0].key === "301") {
            if (selection == "211") {
              let workshopCode = this.serviceDetails.workShop.split("/")[0];
              formDataObj['301'] = new FormControl(workshopCode);
            } else if (selection == "212") {
              formDataObj['301'] = new FormControl("", [Validators.required]);
            } else {
              formDataObj['301'] = new FormControl("", Validators.required);
            }

            var dropDownData = [];
            this.workShops.forEach(element => {
              dropDownData.push({ value: element.workshopCode, viewValue: element.workshopName });
            });
          } else {
            formDataObj[prop.label] = new FormControl("", Validators.required);
            var dropDownData = [];
            prop.data.forEach(element => {
              dropDownData.push({ value: element.key, viewValue: element.value });
            });
          }

        } else if (prop.dataType == "Date") {
          if (selection == "211") {
            let committedDate = new Date(this.serviceDetails.committedDate);
            formDataObj[prop.data[0].key] = new FormControl(committedDate);
          } else if (selection == "213") {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.required]);
          } else if (selection == "202") {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.required]);
          } else if (selection == "212") {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.required]);
          } else {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.required]);
          }

        } else if (prop.dataType == "Number") {
          formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]);
        } else if (prop.dataType == "Time") {
          formDataObj[prop.data[0].key] = new FormControl("");
          // if (this.showBay) {
            formDataObj["bayStartTime"] = new FormControl("");
          // }
        } else {
          formDataObj[prop.data[0].key] = new FormControl("");
        }
        this.level2info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.dataType === "Dropdown" ? dropDownData : prop.data
        });
      }
    }
    if (this.showBay && (selection == "201" || selection == "212")) {
      formDataObj["package"] = new FormControl("");
      this.level2info.push({
        label: "Select Package",
        type: "Dropdown",
        data: this.packagelist
      });
      this.level2info.splice(1, 0, this.level2info.splice(this.level2info.length - 1, 1)[0]);
    }
    this.level2Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel3Form
   * purpose: To create Level3 Form
   * @param {any} data - form data
   */
  createLevel3Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    this.level3Form = undefined;
    this.level3info = [];
    this.level4Form = undefined;
    this.level4info = [];
    this.level5Form = undefined;
    this.level5info = [];
    const formDataObj = {};
    var selection = Object.keys(this.level2Form.controls)[0];
    if (data[this.level2Form.controls[selection].value] && data[this.level2Form.controls[selection].value].length) {
      for (const prop of data[this.level2Form.controls[selection].value]) {
        if (prop.dataType == "Dropdown") {
          formDataObj[prop.label] = new FormControl("", Validators.required);
          var dropDownData = [];
          prop.data.forEach(element => {
            if (this.countryCode == "IND91") {
              if (!(this.serviceDetails.alreadyServicedFlag == "Y" && element.key == "403")) {
                dropDownData.push({ value: element.key, viewValue: element.value });
              }
            } else {
              dropDownData.push({ value: element.key, viewValue: element.value });
            }
          });
        } else if (prop.dataType == "Date") {
          formDataObj[prop.data[0].key] = new FormControl("", Validators.required);
        } else if (prop.dataType == "Number") {
          if (prop.data[0].key == "402") {
            this.milage = parseInt(localStorage.getItem("milage")) + 1;
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.min(this.milage), Validators.required]);
          } else if(prop.data[0].key == "407"){
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]);
          } else {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10), Validators.required]);
          }
        } else {
          formDataObj[prop.data[0].key] = new FormControl("");
        }
        this.level3info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.dataType === "Dropdown" ? dropDownData : prop.data
        });
      }
    }

    this.level3Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel4Form
   * purpose: To create Level4 Form
   * @param {any} data - form data
   */
  createLevel4Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    this.level4Form = undefined;
    this.level4info = [];
    this.level5Form = undefined;
    this.level5info = [];
    const formDataObj = {};
    if (Object.keys(this.level3Form.controls).indexOf("409") !== -1) {
      var selection = "409";
    } else {
      selection = Object.keys(this.level3Form.controls)[0];
    }

    if (data[this.level3Form.controls[selection].value] && data[this.level3Form.controls[selection].value].length) {
      for (const prop of data[this.level3Form.controls[selection].value]) {
        if (prop.dataType == "Dropdown") {
          // if (prop.data[0].key === "502") {
          //   formDataObj['502'] = new FormControl("", Validators.required);
          //   var dropDownData = [];
          //   this.workShops.forEach(element => {
          //     dropDownData.push({ value: element.workshopCode, viewValue: element.workshopName });
          //   });
          // } else {
          formDataObj[prop.label] = new FormControl("", Validators.required);
          var dropDownData = [];
          prop.data.forEach(element => {
            dropDownData.push({ value: element.key, viewValue: element.value });
          });
          //}
        } else if (prop.dataType == "RadioButton") {
          formDataObj["503"] = new FormControl("", Validators.required);
        } else if (prop.dataType == "Text") {
          if (prop.data[0].key == "502") {
            formDataObj[prop.data[0].key] = new FormControl("", Validators.required);
          } else {
            formDataObj[prop.data[0].key] = new FormControl("");
          }
        } else if (prop.dataType == "Date") {
          formDataObj[prop.data[0].key] = new FormControl("", Validators.required);
        } else if (prop.dataType == "Number") {
          if (prop.data[0].key == "506") {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.maxLength(6), Validators.required]);
          } else {
            formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10), Validators.required]);
          }
        }
        this.level4info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.dataType === "Dropdown" ? dropDownData : prop.data
        });
      }
    }

    this.level4Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel5Form
   * purpose: To create Level5 Form
   * @param {any} data - form data
   */
  createLevel5Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    this.level5Form = undefined;
    this.level5info = [];
    const formDataObj = {};
    var selection = this.level4Form.controls["503"].value;
    if (selection == "503" && data[selection] && data[selection].length) {
      for (const prop of data[selection]) {
        if (prop.dataType == "Dropdown") {
          formDataObj[prop.label] = new FormControl("", Validators.required);
          var dropDownData = [];
          prop.data.forEach(element => {
            dropDownData.push({ value: element.key, viewValue: element.value });
          });
        }
        else if (prop.dataType == "Date") {
          formDataObj[prop.data[0].key] = new FormControl("", Validators.required);
        }
        else if (prop.dataType == "RadioButton") {
          formDataObj["503"] = new FormControl("", Validators.required);
        } else if (prop.dataType == "Number") {
          formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10), Validators.required]);
        } else {
          formDataObj[prop.data[0].key] = new FormControl("");
        }
        this.level5info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.dataType === "Dropdown" ? dropDownData : prop.data
        });
      }
      this.level5Form = new FormGroup(formDataObj);
    }
  }

  /**
   * Name: newVehicleClick
   * purpose: To select new vehicle option
   */
  newVehicleClick() {
    this.level3Form.controls["409"].setValue("409");
    this.createLevel4Form(this.responseDropDownData["Level4"]);
  }

  /**
  * Name: hasDataError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasDataError(control: any, form: any): boolean {
    let controler = form.controls[control];
    return (
      controler &&
      (this.formSubmitted || controler.touched || controler.dirty) &&
      !controler.valid
    );
  }

  /**
   * Name: isSaveEnable
   * purpose: To check if save is unable
   */
  isSaveEnable() {
    if (
      this.workshop != "" ||
      this.noResponce != "" ||
      this.odometer != "" ||
      this.yesResponce == "Follow-up" ||
      (this.nsReason != "" && this.nsReason != "Odometer")
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Name: createLevelWiseData
   * purpose: To create LevelWise Data
   */
  createLevelWiseData() {
    let date1 = "";
    var levelResponseData = {};

    if (this.level1Form !== undefined) {
      let obj = {};
      Object.keys(this.level1Form.value).filter(data => {
        obj[this.level1Form.value[data]] = this.level1Form.value[data];
      });
      levelResponseData["Level1"] = obj;
    } else {
      levelResponseData["Level1"] = null;
    }

    if (this.level2Form !== undefined) {
      let selectedDateTime = this.level2Form.value[302] || this.level2Form.value[304];
      if (this.level2Form.value[302] != null) {
        this.level2Form.value[302] = this.datePipe.transform(
          this.level2Form.value[302],
          "yyyy-MM-dd", "+0000"
        );
      }

      if (this.level2Form.value[304] != null) {
        this.level2Form.value[304] = this.datePipe.transform(
          this.level2Form.value[304],
          "yyyy-MM-dd", "+0000"
        );
      }

      if (this.level2Form.value[302] != null) {
        date1 = this.level2Form.value[302];
      } else if (this.level2Form.value[304] != null) {
        date1 = this.level2Form.value[304];
      }

      if (this.level2Form.value[303] != null || selectedDateTime) {
        this.level2Form.value[303] = selectedDateTime;
        this.level2Form.value[303] = this.datePipe.transform(this.level2Form.value[303], "yyyy-MM-ddTHH:mm:ssZ", "+0000");
      }

      if (this.level2Form.value[301] != null) {
        this.level2Form.value[301] = this.level2Form.value[301];
      }

      //bay time selection
      if (selectedDateTime && this.showBay && (levelResponseData['Level1']['201'] != null ||
        levelResponseData['Level1']['212'] != null) && this.level2Form.value["bayStartTime"] != null) {
        //bay selection
        this.level2Form.value[800] = this.selectedBayNo + "";
        //bay time
        let selectedDate = this.datePipe.transform(selectedDateTime, "yyyy-MM-dd");
        let selectedTime = this.datePipe.transform(this.level2Form.value["bayStartTime"], "HH:mm:ss");
        let bayDateTime = new Date(selectedDate + 'T' + selectedTime);
        //service time data data
        this.level2Form.value[302] = this.datePipe.transform(bayDateTime, "yyyy-MM-dd");
        this.level2Form.value[303] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
        //bayForm data
        this.level2Form.value[801] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
        this.level2Form.value["bayStartTime"] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
        //bayendtime
        this.bayEndTime = bayDateTime.setHours(bayDateTime.getHours() + this.serviceHours);
        this.bayEndTime = bayDateTime.setMinutes(bayDateTime.getMinutes() + this.serviceMintus);
        this.bayEndTime = this.datePipe.transform(this.bayEndTime, "HH:mm:ss");
      }
      //bay time selection for titan dealer
      if (selectedDateTime && this.showTitanBay && (levelResponseData['Level1']['201'] != null ||
        levelResponseData['Level1']['212'] != null) && this.level2Form.value["bayStartTime"] != null) {
          this.level2Form.value[800] = this.baySelected + "";
          this.level2Form.value[319] = this.pickUp;
          this.level2Form.value[320] = this.startTitanSlotTime + "-" + this.endTitanSlotTime;
          let selectedDate = this.datePipe.transform(selectedDateTime, "yyyy-MM-dd");
          let selectedTime = this.datePipe.transform(this.level2Form.value["bayStartTime"], "HH:mm:ss");
          let bayDateTime = new Date(selectedDate + 'T' + selectedTime);
          //service time data data
          this.level2Form.value[302] = this.datePipe.transform(bayDateTime, "yyyy-MM-dd");
          this.level2Form.value[303] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
          //bayForm data
          this.level2Form.value[801] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
          this.level2Form.value["bayStartTime"] = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");
          //bayendtime
          this.bayEndTime = bayDateTime.setHours(bayDateTime.getHours() + this.serviceHours);
          this.bayEndTime = bayDateTime.setMinutes(bayDateTime.getMinutes() + this.serviceMintus);
          this.bayEndTime = this.datePipe.transform(this.bayEndTime, "HH:mm:ss");
      }

      // if (this.level2Form.value[307] == "") {
      //   this.level2Form.value[307] = this.level2Form.value[306];
      // }

      let level2formValues = Object.assign({}, this.level2Form.value);
      delete level2formValues['bayStartTime'];
      delete level2formValues[800];
      delete level2formValues[801];
      delete level2formValues['package'];
      levelResponseData["Level2"] = level2formValues;
    } else {
      levelResponseData["Level2"] = null;
    }

    if (this.level3Form !== undefined) {
      levelResponseData["Level3"] = this.level3Form.value;
    } else {
      levelResponseData["Level3"] = null;
    }

    if (this.level4Form !== undefined) {
      var currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd", "+0000");
      if (this.level4Form.value[501] != null) {
        if (this.level4Form.value[501]['_d'] == null) {
          this.level4Form.value[501] = this.datePipe.transform(this.level4Form.value[501], "yyyy-MM-dd", "+0000");
        }
        if (this.level4Form.value[501] != currentDate) {
          this.level4Form.value[501] = this.datePipe.transform(this.level4Form.value[501]['_d'], "yyyy-MM-dd", "+0000");
        }
      }
      levelResponseData["Level4"] = this.level4Form.value;
    } else {
      levelResponseData["Level4"] = null;
    }

    if (this.level5Form !== undefined) {
      levelResponseData["Level5"] = this.level5Form.value;
    } else {
      levelResponseData["Level5"] = null;
    }

    return levelResponseData;
  }

  /**
   * Name: removeSavedVin
   * purpose: To remove Saved Vin
   */
  removeSavedVin(): void {
    const index: number = this.vinNoListArray.indexOf(this.defaultVin);
    if (index !== -1) {
      this.vinNoListArray.splice(index, 1);
    }
    if (this.vinNoListArray.length == 0) {
      this.closeDailog();
      this.router.navigate(["calling"]);
    } else {
      this.defaultVin = this.vinNoListArray[0];
      //config bay
      this.serviceDetails = this.serviceInfo[this.defaultVin];
      this.fertCode = this.serviceDetails.fartCode;
      let serviceType = this.serviceInfo[this.selectedVin].serviceType.split(' - ')[0];
      if(this.workshopAppointmentFlag == 'true') {
        if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          this.showBay = true;
          this.getFertPrice(this.selectedWorkShop, this.fertCode);
        } else {
          this.showBay = false;
        }
      } else {
        this.showBay = false;
      }
      // let serviceType = this.serviceDetails.serviceType.split(' - ')[0];
      // if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
      //   this.showBay = this.workshopAppointmentFlag;
      //   this.getFertPrice(this.selectedWorkShop, this.fertCode);
      // } else {
      //   this.showBay = this.workshopAppointmentFlag;
      // }
      this.bayError = false;

      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.level3Form = undefined;
      this.level3info = [];
      this.level4Form = undefined;
      this.level4info = [];
      this.level5Form = undefined;
      this.level5info = [];
      this.creRemark = null;
      this.submitted = false;
      this.showRemarkError = false;
      this.createLevel1Form(this.responseDropDownData["Level1"]);
    }
  }

  /**
   * Name: sendBookingSMS
   * purpose: To send booking sms
   * @param {boolean} bookingData - booking data
   */
  sendBookingSMS(bookingData: any): void {
    this.spinner = true;
    let bookingDate = this.datePipe.transform(this.level2Form.value[302], "yyyy-mm-dd");
    let bookingTime = this.datePipe.transform(this.level2Form.value[303], "yyyy-MM-ddTHH:mm:ssZ");
    let callType = this.callTypeMap.get(this.serviceInfo[this.defaultVin].callType);
    let request = {
      bkStatus: (callType == 2 || callType == 1 || callType == 3) ? 'R' : 'B',
      bkTime: bookingTime || '',
      bkdate: bookingDate || '',
      contactNo: this.customerNumber || '',
      custName: this.customerData.customerName || '',
      regNo: this.chassisNo || '',
      vin: bookingData.vin || ''
    }
    this.workShops.forEach(workshop => {
      if (workshop.workshopCode == this.selectedWorkShop) {
        request['wSAddress'] = workshop.workshopAddress || '';
        request['wSManager'] = workshop.contactNo || '';
      }
    });
    this.commonService.sendBookingSMS(request).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  checkFormValidation(): boolean {
    let valid = true;
    if (this.talked == "102" && this.noResponce == "") {
      valid = false;
    } else if (this.level1Form !== undefined && !this.level1Form.valid) {
      valid = false;
    } else if (this.level2Form !== undefined && !this.level2Form.valid) {
      valid = false;
    } else if (this.level3Form !== undefined && !this.level3Form.valid) {
      valid = false;
    } else if (this.level4Form !== undefined && !this.level4Form.valid) {
      valid = false;
    } else if (this.level5Form !== undefined && !this.level5Form.valid) {
      valid = false;
    }
    if (this.talked == "101") {
      if ((!this.creRemark && this.noResponce == "209")
        || (!this.creRemark && this.level1Form.value['Select Reason'] == "204"
          && this.level2Form.value['Select Reason'] == "315")) {
        this.showRemarkError = true;
        valid = false;
      }
    }

    // if(this.level1Form.value['Select Reason'] == "203"){
    //   if(this.level2Form.value[306] != "" && this.level2Form.value[305] == "") {
    //     //if(this.level2Form.value[305] == "") {
    //       this.showFleetManError = true;
    //       valid = false;
    //     // } else {
    //     //   this.showFleetManError = false;
    //     // }
    //   }
    // }
    this.submitted = valid;
    return valid;
  }

  /**
   * Name: saveDialData
   * purpose: To save Dial Data
   */
  saveDialData(): void {
    //this.commonService.customerResponse = '';
    this.submitted = true;
    this.formSubmitted = true;
    let packageId;
    if (this.checkFormValidation()) {
      this.showNoRespError = false;
      this.showRemarkError = false;
      var levelData = this.createLevelWiseData();
      this.spinner = true;
      this.callhanged = true;
      let data = "";
      let customerCallStatus = this.yesResponce;
      if (this.yesResponce == "") {
        customerCallStatus = this.noResponce;
        data = this.noResponce;
      }
      if (this.yesResponce == "Booking") {
        if (this.workshop == "Other") {
          data = this.other;
        } else {
          data = this.workshop;
        }
      }

      if (this.yesResponce == "No Service") {
        data = this.nsReason;
        if (this.nsReason == "Odometer") {
          this.other = this.odometer;
        }
      }
      let bay;
      let bayEndTime;
      if (this.level2Form !== undefined && this.showBay && !this.showTitanBay && (levelData['Level1']['201'] != null || levelData['Level1']['212'] != null)) {
        bay = this.selectedBayNo;
        bayEndTime = this.bayEndTime;
      } else if (this.level2Form !== undefined && this.showTitanBay && (levelData['Level1']['201'] != null || levelData['Level1']['212'] != null)) {
        bay = this.baySelected;
        bayEndTime = this.bayEndTime;
      } else {
        bay = '';
        // bayEndTime = this.datePipe.transform(new Date(), "yyyy-MM-dd") + "T00:00:00+0530";
        bayEndTime = "00:00:00";
      }
      if(this.level2Form !== undefined && this.level2Form.value["package"] != null ) {
        packageId = this.level2Form.value["package"];
      } else {
        packageId = '';
      }
      let custData = new CustData(
        this.customerId,
        this.serviceDueDate,
        this.startTime,
        new Date(),
        this.talked,
        this.creRemark,
        this.userID,
        levelData,
        this.noResponce,
        this.defaultVin,
        this.userID,
        bay,
        bayEndTime,
        packageId,
        this.cusType,
        this.phoneNo,
        this.custNameForSave,
        this.userRoles
      );
      let callType = this.serviceInfo[this.defaultVin].callType;

      if (this.level1Form !== undefined && levelData['Level1']['204'] == "204" && (callType == 'Visit' || callType == 'Reminder')) {
        const dialogRef = this.dialog.open(ServicenotrequireDailogComponent, {
          width: '550px',
          data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.saveCallRecording(custData);
          } else {
            this.submitted = false;
          }
        });
      } else {
        this.saveCallRecording(custData);
      }
    } else if (this.talked == "102" && this.noResponce == "") {
      this.showNoRespError = true;
    } else if ((!this.creRemark && this.noResponce == "209")
      || (!this.creRemark && this.level1Form.value['Select Reason'] == "204"
        && this.level2Form.value['Select Reason'] == "315")) {
      this.showRemarkError = true;
    }
  }



  /**
   * Name: updateNumber
   * purpose: To set customer number
   */
  updateNumber(): void {
    let newName = this.level2Form.value[305];
    this.commonService.updateNumber(this.customerNumber, this.primaryNumber, 'Primary', this.customerId, this.userID, this.custName, newName).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    })
  }

  /**
   * Name: getWorkshopBay
   * purpose: To getWorkshopBay
   */
  getWorkshopBay(): void {
    this.commonService.getWorkshopBay(this.userID).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.assignedBay = res["responseData"];
      } else {
       // this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  onBaySelect(bay: number): void {
    // Handle bay selection logic
    this.baySelected = bay;
    this.slotSelected = '';
    let selectedDate = this.datePipe.transform(this.level2Form.value[302], "yyyy-MM-dd");
    this.bayOpen = new Date(selectedDate + 'T' + '');
    this.level2Form.controls.bayStartTime.setValue(this.bayOpen);
    this.startTitanSlotTime = '';
    this.endTitanSlotTime = '';
  }

  onSlotClick(slot: any, startTime: string, endTime: string): void {
    let selectedDate = this.datePipe.transform(this.level2Form.value[302], "yyyy-MM-dd");
    this.bayOpen = new Date(selectedDate + 'T' + startTime);
    this.level2Form.controls.bayStartTime.setValue(this.bayOpen);
    this.startTitanSlotTime = startTime;
    this.endTitanSlotTime = endTime;
    this.slotSelected = slot.slot;
  }
  
  getTitanWorkshopBay(): void {
    this.commonService.getTitanWorkshopBay(this.userID).subscribe(response => {
      if (response["responseCode"] == 0) {
        this.slots = response["responseData"].map(slot => ({
          ...slot,
          start_time: this.formatTime(slot.start_time),
          end_time: this.formatTime(slot.end_time)
        }));
        this.setupDataSource();  
      } else {
        this.toastr.info(response["message"]);
      }
      this.spinner = false;
    }, error => {
      this.toastr.error("Failed to fetch slots", "Error");
      this.spinner = false;
    });
  }

  formatTime(time: string): string {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
  }

  setupDataSource(): void {
    const totalBays = this.slots.length > 0 ? +this.slots[0].total_no_bay : 0;
    const bayData = Array.from({ length: totalBays }, (_, i) => ({
      bay: i + 1,
      ...this.slots.reduce((acc, slot) => {
        acc[slot.slot] = slot.slot; // Add slot data to each bay
        return acc;
      }, {})
    }));
    this.dataSource.data = bayData; // Set the data source
    // Update displayedColumns to include bay and slot columns
    this.displayedColumns = ['bay', ...this.slots.map(slot => slot.slot)];
  }

  isSlotBooked(bay: number, startTime: string): boolean {    
    return this.bookedSlots.some(slot => slot.bay == bay && slot.startTime == startTime);
  }

  isPickUp(status: string): void {
    this.pickUp = status;
  }
  /**
   * Name: getBayVisibility
   * purpose: To getBayVisibility
   */
  getBayVisibility(): void {
    let workShopCode = this.level2Form.value[301];
    let selectedDate = this.datePipe.transform(this.level2Form.value[302], "yyyy-MM-dd");
    this.bayLayout = [];
    this.chartData = [];
    this.commonService.getBayVisibility(workShopCode, selectedDate).subscribe(res => {
      if (res["responseCode"] == 0) {
        if(this.showTitanBay){
          this.showTitanSlotTable = true;
          this.bookedSlots = res["responseData"].map(slot => ({
            bay: slot.bay,
            startTime: this.formatTime(slot.startTime),
            endTime: this.formatTime(slot.endTime)
          }));
        } else {
          if (res["responseData"].length) {
            res["responseData"].sort(function (a, b) {
              let aStartTime = new Date(selectedDate + 'T' + a.startTime);
              let bStartTime = new Date(selectedDate + 'T' + b.startTime);
  
              var aMin = aStartTime.getMinutes();
              var aHrs = aMin > 0 ? aMin / 60 : 0;
              let aTime = aStartTime.getHours() + aHrs;
  
              var bMin = bStartTime.getMinutes();
              var bHrs = bMin > 0 ? bMin / 60 : 0;
              let bTime = bStartTime.getHours() + bHrs;
              return aTime - bTime;
            });
          }
  
          var result = Object.assign([], res["responseData"]);
  
          //get assigned workshop details
          this.assignedBay.forEach(element => {
            if (element.workshopCode == workShopCode) {
              this.workShopBay = element;
            }
          });
          this.workShopBay.bayArea = Object.assign([], res["responseData"]);
          let totalNoBay = Number(this.workShopBay.totalNoBay);
          //set baylayout
          let bayList = [];
          for (let b = 1; b <= totalNoBay; b++) {
            var bay = result.filter(item => item.bay == b);
            bayList.push(bay);
          }
          this.selectedBay = Object.assign([], bayList[0]);
          this.selectedBayNo = bayList.length ? 1 : "";
          this.bayLayout = Object.assign([], bayList);
  
          //get bay details
          this.bayOpen = new Date(selectedDate + 'T' + this.workShopBay.startTime);
          this.bayClose = new Date(selectedDate + 'T' + this.workShopBay.endTime);
          this.level2Form.controls.bayStartTime.setValue(this.bayOpen);
  
          //get chart labels
          let startTime = this.checkHours(this.bayOpen);
          let endTime = this.checkHours(this.bayClose);
  
          this.chartOptions.scales.xAxes[0].ticks.min = startTime;
          this.chartOptions.scales.xAxes[0].ticks.max = endTime;
  
          //fill bay availability
          this.bayLayout.forEach(bayData => {
            let chartData: ChartDataSets[] = [];
            let chartLength = 0;
            let i = startTime;
            for (i; i <= endTime; i++) {
              let slot = {};
              slot['value'] = i;
              slot['available'] = true;
  
              bayData.some((element, index) => {
                //service time
                let serviceStart = new Date(selectedDate + 'T' + element.startTime);
                let serviceEnd = new Date(selectedDate + 'T' + element.endTime);
  
                //final service day hrs
                let serviceStartTime = this.checkHours(serviceStart);
                let serviceEndTime = this.checkHours(serviceEnd);
  
                let serVal = serviceEndTime - serviceStartTime;
  
                if (i >= serviceStartTime) {
                  slot['available'] = false;
                  let chartVal = serVal;
                  if (chartVal > 0) {
                    i = chartData.length ? (i + chartVal - 1) : serviceEndTime - 1;
                    chartVal = chartData.length ? chartVal : serviceStartTime + chartVal;
                    let data: ChartDataSets = {
                      data: [chartVal],
                      stack: 'a',
                      label: 'Occupied',
                      backgroundColor: '#e64243',
                      hoverBackgroundColor: '#e64243',
                      borderSkipped: 'left',
                      borderWidth: 1,
                      borderColor: "#e64243",
                      barThickness: 8
                    }
                    chartLength = chartLength + chartVal;
                    chartData.push(data);
                    bayData.splice(index, 1);
                  }
                  return true;
                } else {
                  let chartVal = serviceStartTime - i;
                  if (chartVal > 0) {
                    i = chartData.length ? (i + chartVal - 1) : serviceStartTime - 1;
                    chartVal = chartData.length ? chartVal : serviceStartTime;
                    let data: ChartDataSets = {
                      data: [chartVal],
                      stack: 'a',
                      label: 'Available',
                      backgroundColor: '#d3d3d3',
                      hoverBackgroundColor: '#d3d3d3',
                      borderSkipped: 'left',
                      borderWidth: 1,
                      borderColor: "#d3d3d3",
                      barThickness: 8
                    }
                    chartLength = chartLength + chartVal;
                    chartData.push(data);
                    return true;
                  }
                }
              });
              if (bayData.length == 0) {
                let chartVal = endTime - chartLength;
                let data: ChartDataSets = {
                  data: [chartVal],
                  stack: 'a',
                  label: 'Available',
                  backgroundColor: '#d3d3d3',
                  hoverBackgroundColor: '#d3d3d3',
                  borderSkipped: 'left',
                  borderWidth: 1,
                  borderColor: "#d3d3d3",
                  barThickness: 8
                }
                chartData.push(data);
                break;
              }
            }
            this.chartData.push(chartData);
          });
  
          if (this.level2Form.value['bayStartTime']) {
            this.checkAvailability(this.level2Form);
          }
        }
      } else {
        this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  /**
   * Name: selectBay
   * purpose: To selectBay
   */
  selectBay(bay: any) {
    this.bayError = false;
    this.selectedBay = this.workShopBay.bayArea.filter(item => item.bay == (bay.value + 1));
    this.selectedBayNo = bay.value + 1;
  }

  /**
   * Name: checkAvailability
   * purpose: To checkAvailability
   */
  checkAvailability(form: any): void {
    this.bayError = false;
    let serviceTime = 0;
    // if(this.division == "LMD") {
    //   serviceTime = 1.5;
    // } else {
    //   serviceTime = 2;
    // }
    if(this.serviceCount>=0){
      if(this.serviceCount % 2 == 1){
        serviceTime = 1.5;
      }else{
        serviceTime = 4;
      }
    }
    let bayOpen = this.checkHours(this.bayOpen);
    let bayClose = this.checkHours(this.bayClose);
    let selectedTime = this.checkHours(new Date(form.value['bayStartTime']));
    let selectedEndTime = selectedTime + serviceTime;
    if (this.selectedBay.length) {
      this.selectedBay.some(element => {
        let date = this.datePipe.transform(this.level2Form.value['bayStartTime'], "yyyy-MM-dd");
        let startDate = new Date(date + 'T' + element.startTime);
        let endDate = new Date(date + 'T' + element.endTime);
        let startTimeS = this.checkHours(startDate);
        let endTimeS = this.checkHours(endDate);
        if ((selectedTime >= startTimeS && selectedTime < endTimeS) ||
          (selectedEndTime > startTimeS && selectedEndTime <= endTimeS) ||
          (selectedEndTime > bayClose) || (selectedTime < bayOpen) ||
          (selectedTime <= startTimeS && selectedEndTime >= endTimeS)) {
          this.bayError = true;
          return true;
        }
      });
    } else {
      let selectedTime = this.checkHours(new Date(form.value['bayStartTime']));
      let selectedEndTime = selectedTime + serviceTime;
      if ((selectedEndTime > bayClose) || (selectedTime < bayOpen)) {
        this.bayError = true;
      }
    }
  }

  /**
   * Name: checkHours
   * purpose: To checkHours
   */
  checkHours(selectedTime) {
    var startMin = selectedTime.getMinutes();
    var hrsOpen = startMin > 0 ? startMin / 60 : 0;
    let startTime = selectedTime.getHours() + hrsOpen;
    return startTime;
  }

  /**
   * Name: getFertPrice
   * purpose: To getFertPrice
   */
  getFertPrice(workShopCode: string, fertCode: string): void {
    this.commonService.getFertPrice(workShopCode, fertCode).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.packagelist = res["responseData"];
        this.packagelist.forEach(element => {
          element.fert = Math.round(Number(element.fert) * 100 + Number.EPSILON) / 100;
        });

        // let fert = this.packagelist.length ? (this.packagelist[0].fert || 2) : 2;
        // this.serviceHours = fert;
      } else {
        //this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      // this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  setPackage(packageId) {
    // this.packagelist.forEach(element => {
    //   if (element.packageId == packageId) {
    //     this.serviceHours = element.fert || 2;
    //   }
    // });
    if (this.level2Form.value['bayStartTime']) {
      this.checkAvailability(this.level2Form);
    }
  }

  getBookingFollowupCount(customerId: string, vin: string) {
    this.commonService.getBookingFollowupCount(customerId, vin, 'srm')
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.bookingCount = res['responseData'].bookingCount;
          this.followupCount = res['responseData'].followUpCount;

        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });

  }

  getWorkshopAppointmentFlag(workShopCode: string, fertCode: string) {
    //this.chartData = [];
    this.commonService.getWorkshopAppointmentFlag(workShopCode)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.workshopAppointmentFlag = res['responseData'][0].appointmentFlag;
          let serviceType = this.serviceInfo[this.selectedVin].serviceType.split(' - ')[0];
          if(this.workshopAppointmentFlag == "true") {
            if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
              this.showBay = true;
              this.getFertPrice(this.selectedWorkShop, this.fertCode);
              if(this.showTitanBay) {
                this.getTitanWorkshopBay();  // Fetch titan workshop slots on initialization
              } else {
                this.getWorkshopBay();
              }
              // if(this.level2Form.value[302] != ""){
              //   this.getBayVisibility();
              // }
            } else {
              this.showBay = false;
            }
          } else {
            this.showBay = false;
          }
          if(this.showBay && this.level2Form.value[302] != ""){
            this.getBayVisibility();
          } else {
            this.chartData = [];
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }


  private saveCallRecording(data:any){
    const URI = localStorage.getItem('exotel_URI')
    const CRE_ID = this.userInfo.userId 
    const CUSTOMER_CODE = this.customerData.customerId
    const SOURCE = "SRM";
    console.log("SAVE" , URI);
    if (URI)
      {
        this.spinner = true;
     
        const callRecordingParams = new SaveCallRecordingParams(CRE_ID,CUSTOMER_CODE,SOURCE,URI)
        this.commonService.saveCallRecording_API(callRecordingParams).subscribe({
          next:(response)=>{
            if (response.responseCode == 0) {
              this.toastr.success(response.message, 'Success')
              this.saveFormResponse(data);
            }
            else
            {
              this.formSubmitted = false;
              this.submitted = false;
              this.toastr.error(response.message, 'Error');
            }
            
          }
          ,error:(error)=>{
            console.log(error);
            this.spinner = false;
            this.formSubmitted = false;
            this.submitted = false;
          },
          complete:()=>{
            this.spinner = false;
           
            
          }
        })
      }
      else{
        this.saveFormResponse(data)
      }
  }

  private saveFormResponse(custResData: any){

    this.commonService.savedata(custResData).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.submitted = false;
          this.toastr.info(res["message"], "Success");
          
          this.router.navigate(["calling"])
          this.commonService.customerResponse = custResData;
          if (this.talked == "101") {
            if (this.level2Form !== undefined && this.level2Form.value[301] != null && this.level2Form.value[302] != null && this.level2Form.value[303] != null) {
              this.sendBookingSMS(custResData);
            }
            if (this.customerNumber != this.primaryNumber && this.isCustomerNumber) {
              this.updateNumber();
            }
            this.removeSavedVin();
          } else {
            this.closeDailog();
            this.router.navigate(["calling"]);
          }
          this.formSubmitted = false;
        } else {
          this.submitted = false;
          this.formSubmitted = false;
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      error => {
        this.submitted = false;
        this.formSubmitted = false;
        this.toastr.error(error, "Error");
        this.spinner = false;
      }
    );
  }
}

class CustData {
  customerId: string;
  serviceDueDate: string;
  callStartTime: string;
  callEndTime: string;
  customerContactInd: string;
  customerCallStatus: string;
  creRemark: string;
  userID: string;
  data: string;
  date: string;
  time: string;
  other: string;
  levelData: object;
  responseForNo: string;
  vin: string;
  dealerCode: string;
  bay: string;
  bayEndTime: any;
  packageValue: any;
  customerType:string;
  phoneNo:string;
  customerName:string;
  role:string;

  constructor(
    customerId,
    serviceDueDate,
    callStartTime,
    callEndTime,
    customerContactInd,
    creRemark,
    userID,
    levelData,
    responseForNo,
    vin,
    dealerCode,
    bay,
    bayEndTime,
    packageValue,
    customerType,
    phoneNo,
    customerName,
    role
  ) {
    this.customerId = customerId;
    this.serviceDueDate = serviceDueDate;
    this.callStartTime = callStartTime;
    this.callEndTime = callEndTime;
    this.customerContactInd = customerContactInd;
    this.creRemark = creRemark;
    this.userID = userID;
    this.levelData = levelData;
    this.responseForNo = responseForNo;
    this.vin = vin;
    this.dealerCode = dealerCode;
    this.bay = bay;
    this.bayEndTime = bayEndTime;
    this.packageValue = packageValue;
    this.customerType=customerType;
    this.phoneNo=phoneNo;
    this.customerName=customerName;
    this.role=role;
  }
}